import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { KIND, answerBody, answerOptions } from "@/components/SpecialSituations";
import { Glossed } from "@/components/Glossary";

function Row({ k, q, value, detected, onPick }) {
  return (
    <div className="py-3.5" data-testid={`qd-${k}`}>
      <div className="text-[15px] font-semibold navy-text"><Glossed text={q.ask} /></div>
      <p className="text-sm text-slate-500 mt-0.5"><Glossed text={q.why} /></p>
      {detected && <p className="text-xs text-sky-900 bg-sky-50 border border-sky-200 rounded-md px-2.5 py-1.5 mt-2">Detetado nos documentos: {detected}</p>}
      <div className="flex gap-1.5 mt-2.5">
        {answerOptions(KIND[k]).map(([v, l]) => (
          <button key={l} type="button" onClick={() => onPick(k, value === v ? undefined : v)} data-testid={`qd-${k}-${l.toLowerCase().replace(" ", "-")}`}
            className={`px-3.5 py-1.5 text-sm rounded-md border transition-colors ${value === v ? "bg-ec-green text-white border-ec-green" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}

export function QuestionsDialog({ p, keys, who, onClose, onSaved }) {
  const [ans, setAns] = useState({});
  const [busy, setBusy] = useState(false);
  const picked = Object.keys(ans).filter((k) => ans[k] !== undefined);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/processes/${p.id}`, Object.assign({}, ...picked.map((k) => answerBody(k, ans[k]))));
      toast.success(picked.length === 1 ? "Resposta guardada" : `${picked.length} respostas guardadas`);
      onSaved(); onClose();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-lg max-h-[85vh] overflow-y-auto" data-testid="questions-dialog">
        <DialogHeader>
          <DialogTitle>{keys.length === 1 ? `Pergunta ao ${who}` : `Perguntas ao ${who}`}</DialogTitle>
          <DialogDescription>Responda às que já sabe. As outras ficam por responder.</DialogDescription>
        </DialogHeader>
        <div className="divide-y divide-slate-100">
          {keys.map((k) => <Row key={k} k={k} q={p.questions?.[k] || { ask: k, why: "" }} value={ans[k]} detected={(p.detected || {})[k]} onPick={(kk, v) => setAns((a) => ({ ...a, [kk]: v }))} />)}
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button onClick={onClose} className="h-9 px-3.5 rounded-lg text-sm font-semibold text-slate-600 hover:bg-slate-50" data-testid="qd-cancel">Cancelar</button>
          <button onClick={save} disabled={!picked.length || busy} className="h-9 px-4 rounded-lg text-sm font-semibold navy-bg text-white disabled:opacity-50" data-testid="qd-save">
            Guardar{picked.length ? ` (${picked.length})` : ""}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
